module.exports = __webpack_public_path__ + "img/p23.84487481.png";